module.exports = __webpack_public_path__ + "static/NightInTheWoods6-2037643eeae1fbfbeb980af3f46b0937.webp";